export default __webpack_public_path__ + "media/images/features/local_delivery/episode1/LP_01-5927e8768a6ef3b8fa1f898ad75d0c79.jpg";